import { z } from 'zod';

export const CategoryCodeZod = z.union([
    z.literal('estate_plan'),
    z.literal('supporting'),
    z.literal('gift_trust'),
    z.literal('gift_trust_supporting'),
]);

export type CategoryCode = z.infer<typeof CategoryCodeZod>;
